import * as Scrivito from "scrivito";
import { localizeAttrList } from "^/utils/localizeAttribute";
import galleryWidgetIcon from "../../assets/images/gallery_widget.svg";

Scrivito.provideEditingConfig("GalleryWidget", {
  title: "Gallery",
  thumbnail: galleryWidgetIcon,
  attributes: localizeAttrList(["dotsDescription", "images"], "GalleryWidget"),
  properties: ["images", "dotsDescription"],
  initialContent: {
    dotsDescription: "Foliennummer",
  },
});
